module.exports = __webpack_public_path__ + "static/media/loking.7fe07527.gif";